import $ from 'jquery';
import { initSubmenuExportTypeChangeListeners } from '~core/navbar/submenus/export';

export const toggleVideoMakerView = (pages = []) => {
  const hasAnimation = pages.some(
    (page) => page.animations && page.animations.length > 0
  );

  if (hasAnimation) {
    // TODO
    $('#giotto-video-preview, #btn-sidebar-animations').removeClass('d-none');
    initSubmenuExportTypeChangeListeners(
      [{ id: 'MP4', text: 'Video (MP4)' }],
      'MP4'
    );
    setTimeout(() => {
      // Required because on load, the actual initSubmenuExportTypeChangeListeners resets everything
      initSubmenuExportTypeChangeListeners(
        [{ id: 'MP4', text: 'Video (MP4)' }],
        'MP4'
      );
    }, 1000);
  } else {
    $('#giotto-video-preview, #btn-sidebar-animations').addClass('d-none');
    initSubmenuExportTypeChangeListeners();
  }
};
